export default __webpack_public_path__ + "choose_bundle_corner_1.021480.svg";